var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('TheLayoutWrap',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1):_c('AppSpinner',{attrs:{"loading":true}})}
var staticRenderFns = []

export { render, staticRenderFns }